module.exports = __webpack_public_path__ + "images/fa-cm-bg-billing-mobile.webp";